/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-case-declarations */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable consistent-return */
import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import {
  Box,
  UnstyledHtmlAnchor,
  StudioDesignSystem,
  NFTGhostItem,
  ActivityIndicator,
  FrameworkImage,
} from '@ttx/design-system';
import { GetStaticPaths, GetStaticProps } from 'next';
import Head from 'next/head';
import { ResultOf } from '@graphql-typed-document-node/core';
import { renderMetaTags, SeoMetaTagType } from 'react-datocms';
import { useBreakpoint } from '@ttx/design-system/src/use-breakpoint';
import { useRouter } from 'next/router';
import { request } from '../../graphql/api';
import {
  ArtistDocument,
  AllStudiosDocument,
  StudioDocument,
} from '../../graphql/generated';
import { NextPageWithPageLayoutOptions } from '../../components/page-layout/types';
import { useTtxMutation } from '../../hooks/ttx-trpc';
import { isElementInView } from '../../utils';
import { useEmailSignup } from '../../hooks/use-email-signup';
import { STUDIO_MENUS } from '../../utils/consts';
import { NoNft } from '../../components/no-nft/no-nft';
import { removeLoader } from '../../utils/webflow-util';
import { useStudioProperties } from '../../utils/studio-util';
import './studio.module.css';
import { HomePageConatiner } from '../../components/home-page-components/container-section';
import { SubscriptionSection } from '../../components/home-page-components/subscription-section';
import { Partner } from '../about/types';

const {
  CoverImageCuration,
  FeatureArtistCard,
  HeroNFTV3,
  NftGridList,
  NFTTrackCard,
  Typography,
  Navbar,
  Footer,
} = StudioDesignSystem;

interface PartnerProps extends Partner {
  width: number;
  height: number;
}

const partnersData: PartnerProps[] = [
  {image: '/partner-logos/image-1.png', url: '#', width: 180, height: 200},
  {image: '/partner-logos/polygon.svg', url: '#', width: 180, height: 200},
  {image: '/partner-logos/tiktok.png', url: '#', width: 180, height: 150},
  {image: '/partner-logos/rarible.png', url: '#', width: 180, height: 150},
];

const StudioPage: NextPageWithPageLayoutOptions<
  | {
      studio: ResultOf<typeof StudioDocument>['studio'];
      slug: string;
      site: ResultOf<typeof ArtistDocument>['site'];
    }
  | Record<string, never>
> = (props) => {
  const [animationTriggered, setAnimationTriggered] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const quoteBlockRef = useRef(null);
  const {currentBreakpoint} = useBreakpoint();
  const router = useRouter();
  const {slug = ''} = router.query;

  const {
    themeColor,
    cssClasses,
    isLoading: isStudioLoading,
    studioContent,
  } = useStudioProperties();

  useEffect(() => {
    setIsMobile(currentBreakpoint === '768px');
  }, [currentBreakpoint]);

  const onScroll = () => {
    if (
      !animationTriggered &&
      quoteBlockRef.current &&
      isElementInView(quoteBlockRef.current)
    ) {
      setAnimationTriggered(true);
      document.removeEventListener('scroll', onScroll, true);
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', onScroll, true);
    removeLoader();
    return () => {
      document.removeEventListener('scroll', onScroll, true);
    };
  }, []);

  const {isLoading, ...collectionListMutation} =
    useTtxMutation('collection.list');

  useEffect(() => {
    collectionListMutation.mutate({
      limit: 0,
      page: 1,
      creator: undefined,
      collectionStatus: ['minted', 'draft'],
      nftStatus: ['minted', 'draft'],
      artistSlug: props.slug,
      includeFeatures: true,
      isCollaborators: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const latestCollection = useMemo(
    () =>
      collectionListMutation.data
        ?.filter(
          (item) =>
            item?.creatorDetails?.user?.slug === props.slug
        )
        .shift(),
    [collectionListMutation.data, props.slug],
  );
  
  

  const firstItemInLatestCollection = latestCollection?.nftTokenIds[0];

  const {onSignupSubmit} = useEmailSignup({
    collectionId: latestCollection?._id
      ? latestCollection?._id.toString()
      : props.slug,
    artistSlug: props.slug,
  });

  const data = useMemo(
    () =>
      latestCollection
        ? latestCollection.nftTokenIds.map((item) => ({
            ...item,
            network: latestCollection.blockchainNetworkDetail.network,
            contractAddress: latestCollection.contractAddress,
            multiCopy: latestCollection.multiCopy,
          }))
        : [],
    [latestCollection],
  );
  const creatorName = latestCollection?.creatorDetails.user.displayName || '';
  const network = latestCollection?.blockchainNetworkDetail.network;

  const nextDropDate = useMemo(
    () =>
      latestCollection?.mintedAtUTC
        ? new Date(latestCollection.mintedAtUTC)
        : null,
    [latestCollection?.mintedAtUTC],
  );

  const renderItem = useCallback((item: any) => {
    const comingSoonNftsBlockRecord: any = sections?.find(
      (e) => e.__typename === 'OtherReleaseRecord',
    );
    let href = {};
    if (item.url) {
      const splitNFTSlug = item.url.split('/');
      const nftSlug = splitNFTSlug[splitNFTSlug.length - 1];
      href = {href: `nft/${slug}/${nftSlug}`};
    }
    return (
      <UnstyledHtmlAnchor target="_blank" {...href}>
        <NFTTrackCard
          key={item._id}
          src={item?.image?.url || ''}
          artist={item.artistName}
          trackName={item.title}
          isVideo={item.isVideo}
          price={item.price}
          currencySymbol={item.currency}
          network={comingSoonNftsBlockRecord?.network || 'ethereum'}
          state="available"
          totalSupply={item.quantityAvailable}
          // hasBorder
          description={item.description}
        />
      </UnstyledHtmlAnchor>
    );
  }, []);
  const renderFeatureItem = useCallback(
    (item: any) => {
      return (
        <FeatureArtistCard
          key={item.artistName}
          src={item?.image?.url || ''}
          artist={item.artistName}
          isMobile={isMobile}
          onPress={() => {
            const splitSlug = item.url.split('/');
            const artistSlug = splitSlug[splitSlug.length - 1];
            if (window && window.open && artistSlug) {
              window.open(`artists/${slug}/${artistSlug}`, '_blank')?.focus();
            }
            // router.push(`artists/${slug}/${artistSlug}`);
          }}
          hasBorder
        />
      );
    },
    [isMobile],
  );

  const {studio, site} = props;
  const sections = studio?.sections;

  // Theme Config
  const backgroundThemeColor = studio?.backgroundThemeColor?.hex
    ? studio?.backgroundThemeColor?.hex
    : STUDIO_MENUS[slug as keyof typeof STUDIO_MENUS]?.backgroundThemeColor;
  const textColor = studio?.themeFontColor?.hex
    ? studio?.themeFontColor?.hex
    : STUDIO_MENUS[slug as keyof typeof STUDIO_MENUS]?.textColor;
  const themeFont = studio?.themeFontFamily
    ? studio?.themeFontFamily
    : STUDIO_MENUS[slug as keyof typeof STUDIO_MENUS]?.fonts.altone;

  // const {logo, fonts, title} = STUDIO_MENUS['wild-awake'];
  const {buttonBGColor} = STUDIO_MENUS[slug as keyof typeof STUDIO_MENUS] || {
    buttonBGColor: '',
  };

  // End Theme Config

  const headerSection = () => {
    const coverImageSection: any = sections?.find(
      (e) => e.__typename === 'CoverImageRecord',
    );
    if (!coverImageSection) {
      return null;
    }
    return (
      <Box>
        <CoverImageCuration
          image={
            coverImageSection?.image?.url
              ? coverImageSection?.image?.url
              : latestCollection?.backgroundImage
          }
          logo={coverImageSection?.logo?.url}
          artistName={undefined}
        />
      </Box>
    );
  };

  const CurationDescription = () => {
    return (
      <Box marginTop="ten">
        {/* <Box
          width="130px"
          marginLeft="five"
          borderBottomColor="outlines"
          borderBottomWidth="zero"
          borderBottomStyle="solid"
        >
          <Typography
            css={{
              color: 'var(--studio-secondaryText)',
              'line-height': '1.8em !important',
            }}
            fontFamily="abc"
            fontSize="xm"
          >
            WELCOME
          </Typography>
        </Box> */}
        <Box
          // borderTopColor="grey24"
          // borderTopWidth="one"
          // borderTopStyle="solid"
          // paddingTop="eight"
          paddingLeft="five"
          paddingRight="six"
          paddingBottom="ten"
        >
          <Typography
            css={{
              color: 'var(--studio-secondaryText)',
              'line-height': '1.8em !important',
              'font-size': props.slug === 'goodwood-fractionalised-horse-ownership'
                ? '18px'
                : '14px', 
            }}
          >
            {studio?.curationDescription || ''}
          </Typography>
        </Box>
        {slug === 'my-sahel' && (
          <video width="100%" height="auto" controls autoPlay muted>
            <source src="https://traxxbucket-prod.s3.amazonaws.com/gated-perks/video/My_Sahel_Song_FineCut_180723.mov" />
          </video>
        )}
      </Box>
    );
  };

  const getHeroNFT = () => {
    const heroNftCurationRecord: any = sections?.find(
      (e) => e.__typename === 'HeroNftCurationRecord',
    );
    const comingSoonNftsBlockRecord: any = sections?.find(
      (e) => e.__typename === 'OtherReleaseRecord',
    );
    if (heroNftCurationRecord) {
      return (
        <Box marginTop="five">
          {props.slug === 'openlab' && (
            <Box marginBottom="six" marginLeft="five">
              <Typography
                css={{
                  color: 'var(--studio-primaryText)',
                  'line-height': '1em !important',
                }}
                fontSize="h2"
                fontWeight="regular"
                textAlign="center"
              >
                OPENLAB DIGITAL MEMBERSHIP
              </Typography>
            </Box>
          )}

          {props.slug === 'goodwood-fractionalised-horse-ownership' && (
            <Box marginBottom="six" marginLeft="five">
              <Typography
                css={{
                  color: 'var(--studio-primaryText)',
                  'line-height': '1em !important',
                }}
                fontSize="h2"
                fontWeight="regular"
                textAlign="center"
              >
                 GOODWOOD   HORSE   SHARES
              </Typography>
            </Box>
          )}


          <Box key={heroNftCurationRecord.id}>
            <HeroNFTV3
              image={heroNftCurationRecord?.nftImage.url}
              url={heroNftCurationRecord?.url}
              artistName={heroNftCurationRecord.artistName}
              nftName={heroNftCurationRecord.nftName}
              nftDescription={
                heroNftCurationRecord?.nftDescription ||
                firstItemInLatestCollection?.description
              }
              onPress={() => {
                const splitNFTSlug = heroNftCurationRecord.url.split('/');
                const nftSlug = splitNFTSlug[splitNFTSlug.length - 1];
                if (window && window.open) {
                  window.open(`nft/${slug}/${nftSlug}`, '_blank')?.focus();
                }
              }}
              currencySymbol={heroNftCurationRecord.currency}
              network={comingSoonNftsBlockRecord?.network}
              price={heroNftCurationRecord.nftPrice}
              buttonCta={heroNftCurationRecord?.buttonCta}
              dateAdded={new Date(heroNftCurationRecord?.dateAdded)}
            />
          </Box>
        </Box>
      );
    }
    return null;
  };

  const OtherReleases = () => {
    const comingSoonNftsBlockRecord: any = sections?.find(
      (e) => e.__typename === 'OtherReleaseRecord',
    );
    // if (!comingSoonNftsBlockRecord?.nfts?.length) {
    //   return (
    //     <NoNft
    //       title="This artist doesn’t have any NFTs yet."
    //       subtitle="Find out more about their work here"
    //     />
    //   );
    // }
    if (comingSoonNftsBlockRecord?.nfts?.length) {
      return (
        <Box marginTop="twentyFive">
          <Box marginBottom="five" marginLeft="five">
            <Typography
              color="textDefault"
              fontWeight="regular"
              fontSize="h2"
              css={{
                color: 'var(--studio-primaryText)',
              }}
            >
              {studioContent.collection}
            </Typography>
          </Box>
          <NftGridList
            columns={
              studioContent?.collectionGridColumns as [
                number,
                number,
                number,
                number,
              ]
            }
            rowSpace="xxs"
            columnSpace="xxs"
            keyExtractor={(item: {_id: string}) => item._id}
            loading={isLoading}
            items={comingSoonNftsBlockRecord?.nfts}
            error=""
            renderItem={renderItem}
          />
        </Box>
      );
    }
  };

  const FeatureArtist = () => {
    const featureartistlist: any = sections?.find(
      (e) => e.__typename === 'FeatureartistlistRecord',
    );
    if (!featureartistlist?.artists?.length) {
      return null;
    }
    return (
      <Box marginTop="twentyFive">
        <Box marginBottom="five" marginLeft="eight">
          <Typography
            color="textDefault"
            fontWeight="regular"
            fontSize="h2"
            css={{
              color: 'var(--studio-primaryText)',
            }}
          >
            {  slug == 'goodwood-fractionalised-horse-ownership' ? 'COURSE HORSES' : studioContent.artists || 'ARTISTS'}
          </Typography>
        </Box>
        <NftGridList
          columns={[1, 3, 3, 3]}
          rowSpace="xxs"
          columnSpace="xxs"
          keyExtractor={(item: {_id: string}) => item._id}
          loading={isLoading}
          items={featureartistlist?.artists}
          error=""
          renderItem={renderFeatureItem}
        />
      </Box>
    );
  };

  const tabViewPageSections = () => {
    return (
      <Box mb="twentyFive">
        {headerSection()}
        {CurationDescription()}
        {getHeroNFT()}
        {OtherReleases()}
        {FeatureArtist()}
      </Box>
    );
  };
  // , studioContent.collectionGridColumns, studioContent.collection
  return (
    <Box>
      {isStudioLoading && cssClasses ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '90vh',
          }}
        >
          <ActivityIndicator
            color="brandPrimary"
            loaderColor="brandPrimary"
            size={60}
          />
        </div>
      ) : (
        <>
          <Head>
            <title>{studio?.artistName}</title>
          </Head>
          <Head>
            {renderMetaTags(
              (studio?.seo?.concat(site?.favicon || []) ||
                []) as SeoMetaTagType[],
            )}
            <style>{cssClasses}</style>
          </Head>
          <Box
          // borderBottomColor="grey24"
          // borderBottomWidth="one"
          // borderBottomStyle="solid"
          >
            {/* {cmsPageSections.length ? cmsPageSections : fallbackPageSections} */}
            {tabViewPageSections()}
          </Box>
          {slug === 'my-sahel' && (
            <>
              <Box>
                <Typography
                  lineHeight="biglead"
                  fontWeight="regular"
                  color="textLow"
                  fontSize="h2"
                >
                  PARTNERS
                </Typography>
              </Box>
              <Box
                flexDirection="row"
                width="100%"
                alignItems="center"
                flexWrap="wrap"
              >
                {partnersData.map((partner) => {
                  return (
                    <Box
                      flex={['100%', '50%', '33.33%', '33.33%']}
                      alignItems="center"
                      justifyContent="center"
                      key={partner.url}
                    >
                      <UnstyledHtmlAnchor
                        target="_blank"
                        href={partner.url}
                        rel="noopener noreferrer"
                      >
                        <Box height={partner.height} width={partner.width}>
                          <FrameworkImage
                            src={partner.image}
                            layout="fill"
                            objectFit="contain"
                          />
                        </Box>
                      </UnstyledHtmlAnchor>
                    </Box>
                  );
                })}
              </Box>
              <Box marginBottom={['seven', 'zero']}>
                <HomePageConatiner isMobile={isMobile}>
                  <SubscriptionSection
                    isMobile={isMobile}
                    subscribeInfo={{subscribeTemplate: 80, subscribeList: 27}}
                  />
                </HomePageConatiner>
              </Box>
            </>
          )}
        </>
      )}
    </Box>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  const result = await request(AllStudiosDocument);

  return {
    fallback: true,
    paths: result.allStudios
      .filter((page) => page.slug)
      .map((page) => ({
        params: {
          slug: page.slug as string,
        },
      })),
  };
};

export const getStaticProps: GetStaticProps<any, {slug: string}> = async ({
  params,
  preview,
}) => {
  if (!params) return {props: {}};
  const studioResult = await request(
    StudioDocument,
    {slug: params.slug},
    preview,
  );
  return {
    revalidate: 60,
    props: {
      studio: studioResult.studio,
      slug: params.slug,
      preview: preview ?? false,
      site: studioResult.site,
    },
  };
};

StudioPage.pageLayoutOptions = {
  showFooter: true,
  showNavbar: true,
};

export default StudioPage;
